module.exports = __webpack_public_path__ + "static/bg1-32e57db576ed89529d2bf2dce859ef3f.png";